<template>
    <p>Are you sure you want to delete this Transaction Type?</p>
    <br />
    <p>[ {{ item.name }} ]</p>
</template>

<script setup lang="ts">
import { useInjectSubmitForm } from '@shared/composables/action-dialog/useInjectSubmitForm';
import { type ITransactionType } from '@app/purchase/transaction-type/models/TransactionType.ts';
import { useTransactionTypeRepository } from '@app/purchase/transaction-type/repositories/useTransactionTypeRepository';

const props = defineProps({
    item: {
        type: Object as PropType<ITransactionType>,
        required: true,
    },
});

const destroy = useTransactionTypeRepository().command.destroy(props.item.id);
useInjectSubmitForm(destroy.execute);
</script>
